<template>
    <div id="controls">
        <div class="AddGroup">
            <template v-if="!$utils.browser.isWeiXin()">
                <a href="https://jq.qq.com/?_wv=1027&k=EZyhwiRR" target="_blank">开黑群：658858067</a>
                <a href="https://jq.qq.com/?_wv=1027&k=HDO83lXq" target="_blank">说书人交流群：1030281506</a>
                <a href="https://jq.qq.com/?_wv=1027&k=E93W4jYJ" target="_blank">工具使用培训群：697349612</a>
            </template>
            <template v-else>
                <a href="javascript:;">开黑群：658858067</a>
                <a href="javascript:;">说书人交流群：1030281506</a>
                <a href="javascript:;">工具使用培训群：697349612</a>
            </template>
        </div>
        <a v-if="!$utils.browser.isWeiXin()" href="javascript:;" @click.stop="gotozq()" class="GameIntroduction"
            >游戏攻略</a
        >
        <span
            class="nomlog-summary"
            v-show="session.voteHistory.length && session.sessionId"
            @click="toggleModal('voteHistory')"
            :title="
                `${session.voteHistory.length} recent ${session.voteHistory.length == 1 ? 'nomination' : 'nominations'}`
            "
        >
            <font-awesome-icon icon="book-dead" />
            {{ session.voteHistory.length }}
        </span>
        <span
            class="session"
            :class="{
                spectator: session.isSpectator,
                reconnecting: session.isReconnecting
            }"
            v-if="session.sessionId"
            @click="leaveSession"
            :title="
                `${session.playerCount} other players in this session${
                    session.ping ? ' (' + session.ping + 'ms latency)' : ''
                }`
            "
        >
            <font-awesome-icon icon="broadcast-tower" />
            {{ session.playerCount }}
        </span>

        <div class="menu" :class="{ open: grimoire.isMenuOpen }">
            <font-awesome-icon icon="cog" @click="toggleMenu" />
            <ul>
                <li class="tabs" :class="tab">
                    <font-awesome-icon icon="book-open" @click="tab = 'grimoire'" />
                    <font-awesome-icon icon="broadcast-tower" @click="tab = 'session'" />
                    <font-awesome-icon icon="users" v-if="!session.isSpectator" @click="tab = 'players'" />
                    <font-awesome-icon icon="theater-masks" @click="tab = 'characters'" />
                    <font-awesome-icon icon="question" @click="tab = 'help'" />
                </li>

                <template v-if="tab === 'grimoire'">
                    <!-- Grimoire -->
                    <li class="headline">魔法书</li>
                    <li @click="toggleGrimoire" v-if="players.length">
                        <template v-if="!grimoire.isPublic">隐藏身份</template>
                        <template v-if="grimoire.isPublic">显示身份</template>
                        <em>[G]</em>
                    </li>
                    <li @click="toggleNight" v-if="!session.isSpectator">
                        <template v-if="!grimoire.isNight">切换到夜晚</template>
                        <template v-if="grimoire.isNight">切换到白天</template>
                        <em>[S]</em>
                    </li>
                    <li @click="toggleNightOrder" v-if="players.length">
                        夜晚顺序
                        <em>
                            <font-awesome-icon :icon="['fas', grimoire.isNightOrder ? 'check-square' : 'square']" />
                        </em>
                    </li>
                    <li v-if="players.length">
                        缩放
                        <em>
                            <font-awesome-icon @click="setZoom(grimoire.zoom - 1)" icon="search-minus" />
                            {{ Math.round(100 + grimoire.zoom * 10) }}%
                            <font-awesome-icon @click="setZoom(grimoire.zoom + 1)" icon="search-plus" />
                        </em>
                    </li>
                    <li @click="setBackground">
                        背景图片
                        <em><font-awesome-icon icon="image"/></em>
                    </li>
                    <li v-if="!edition.isOfficial" @click="imageOptIn">
                        <small>是否显示自定义图片</small>
                        <em><font-awesome-icon :icon="['fas', grimoire.isImageOptIn ? 'check-square' : 'square']"/></em>
                    </li>
                    <li @click="toggleStatic">
                        关闭动画
                        <em><font-awesome-icon :icon="['fas', grimoire.isStatic ? 'check-square' : 'square']"/></em>
                    </li>
                    <li @click="toggleMuted">
                        静音
                        <em><font-awesome-icon :icon="['fas', grimoire.isMuted ? 'volume-mute' : 'volume-up']"/></em>
                    </li>
                    <li @click="generatePoster()">
                        生成玩家海报
                        <em><font-awesome-icon icon="address-card"/></em>
                    </li>
                </template>

                <template v-if="tab === 'session'">
                    <!-- Session -->
                    <li class="headline" v-if="session.sessionId">
                        {{ session.isSpectator ? "玩家" : "说书人" }}
                    </li>
                    <li class="headline" v-else>
                        房间
                    </li>
                    <template v-if="!session.sessionId">
                        <li @click="hostSession">创建小镇（说书人）<em>[H]</em></li>
                        <li @click="joinSession">加入小镇（用户）<em>[J]</em></li>
                    </template>
                    <template v-else>
                        <li v-if="session.ping">
                            与 {{ session.isSpectator ? "主机" : "玩家" }} 的延迟:
                            <em>{{ session.ping }}ms</em>
                        </li>
                        <!-- <li @click="copySessionUrl">
              复制玩家链接
              <em><font-awesome-icon icon="copy"/></em>
            </li> -->
                        <li v-if="!session.isSpectator" @click="distributeRoles">
                            分配角色
                            <em><font-awesome-icon icon="theater-masks"/></em>
                        </li>
                        <li
                            v-if="session.voteHistory.length || !session.isSpectator"
                            @click="toggleModal('voteHistory')"
                        >
                            投票记录<em>[V]</em>
                        </li>
                        <li @click="leaveSession">
                            离开房间
                            <em>{{ session.sessionId }}</em>
                        </li>
                    </template>
                    <template v-if="$utils.cookie('UserCookie')">
                        <li @click="loginOut">退出登录</li>
                    </template>
                </template>

                <template v-if="tab === 'players' && !session.isSpectator">
                    <!-- Users -->
                    <li class="headline">座位列表</li>
                    <li @click="addPlayer" v-if="players.length < 20">添加座位<em>[A]</em></li>
                    <li @click="randomizeSeatings" v-if="players.length > 2">
                        打乱座位
                        <em><font-awesome-icon icon="dice"/></em>
                    </li>
                    <li @click="clearPlayers" v-if="players.length">
                        移除全部
                        <em><font-awesome-icon icon="trash-alt"/></em>
                    </li>
                </template>

                <template v-if="tab === 'characters'">
                    <!-- Characters -->
                    <li class="headline">角色</li>
                    <li v-if="!session.isSpectator" @click="toggleModal('edition')">
                        选择剧本
                        <em>[E]</em>
                    </li>
                    <li @click="toggleModal('roles')" v-if="!session.isSpectator && players.length > 4">
                        选择&分配角色
                        <em>[C]</em>
                    </li>
                    <li v-if="!session.isSpectator" @click="toggleModal('fabled')">
                        添加传奇角色
                        <em><font-awesome-icon icon="dragon"/></em>
                    </li>
                    <li>
                        <a href="https://diygrimoire-static-4d879eef1df86-1311394090.tcloudbaseapp.com">DIY剧本工具</a>
                    </li>
                    <li @click="clearRoles" v-if="players.length">
                        移除全部
                        <em><font-awesome-icon icon="trash-alt"/></em>
                    </li>
                </template>

                <template v-if="tab === 'help'">
                    <!-- Help -->
                    <li class="headline">帮助</li>
                    <li @click="toggleModal('reference')">
                        角色列表
                        <em>[R]</em>
                    </li>

                    <li @click="toggleModal('nightOrder')">
                        夜间行动顺序
                        <em>[N]</em>
                    </li>
                    <li @click="toggleModal('gameState')">
                        游戏存档代码
                        <em><font-awesome-icon icon="file-code"/></em>
                    </li>

                    <!-- @click="loadPresetCard(presetcard)" -->

                    <template v-if="!session.isSpectator">
                        <div
                            class="cardGroup"
                            v-for="(cartype, carIndex) in presetcards"
                            :key="cartype.typeName"
                            @click.stop="cardGroupCur == carIndex ? (cardGroupCur = -1) : (cardGroupCur = carIndex)"
                        >
                            <div class="cardTypeName">
                                {{ cartype.typeName }}
                                <em><font-awesome-icon icon="angle-down"/></em>
                            </div>
                            <li
                                class="presetcardsList"
                                v-for="(match, mindex) in cartype.cardGroup"
                                :key="match.title"
                                @click.stop="presetcardCur == mindex ? (presetcardCur = -1) : (presetcardCur = mindex)"
                                v-show="cardGroupCur == carIndex"
                            >
                                <div class="tabTitle">
                                    {{ match.title }}
                                    <em><font-awesome-icon icon="angle-down"/></em>
                                </div>
                                <div class="presetcard-box" v-show="presetcardCur == mindex">
                                    <a
                                        href="javascript:;"
                                        v-for="presetcard in match.presetcards"
                                        :key="presetcard.id"
                                        @click.stop="loadPresetCard(presetcard)"
                                    >
                                        {{ presetcard.id }}
                                    </a>
                                </div>
                            </li>
                        </div>
                    </template>

                    <!-- <li>
            <a href="https://jq.qq.com/?_wv=1027&k=hWHuQZgG">
              开黑加群：658858067
            </a>
          </li> -->
                    <!-- <li>
            <a href="https://discord.gg/Gd7ybwWbFk" target="_blank">
              Join Discord
            </a>
            <em>
              <a href="https://discord.gg/Gd7ybwWbFk" target="_blank">
                <font-awesome-icon :icon="['fab', 'discord']" />
              </a>
            </em>
          </li>
          <li>
            <a href="https://github.com/bra1n/townsquare" target="_blank">
              Source code
            </a>
            <em>
              <a href="https://github.com/bra1n/townsquare" target="_blank">
                <font-awesome-icon :icon="['fab', 'github']" />
              </a>
            </em>
          </li> -->
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import Bus from "../bus";
import { mapMutations, mapState } from "vuex";
import presetcardJSON from "../presetcard.json";
export default {
    computed: {
        ...mapState(["grimoire", "session", "edition"]),
        ...mapState("players", ["players"])
    },
    data() {
        return {
            tab: "grimoire",
            presetcards: presetcardJSON,
            presetcardCur: -1,
            cardGroupCur: -1
        };
    },
    mounted() {
        console.log(presetcardJSON);
    },
    methods: {
        setBackground() {
            this.$alert({
                title: "输入自定义背景图地址"
            }).then(val => {
                if (val || val === "") {
                    this.$store.commit("setBackground", val);
                }
            });
        },
        hostSession() {
            if (!this.$utils.cookie("UserCookie")) {
                this.toggleModal("loginBox");
                return;
            }
            if (this.session.sessionId) return;
            this.$createroom({
                title: "输入你想创建的房间号码/名称",
                value: Math.round(Math.random() * 10000)
            }).then(response => {
                this.$store.commit("session/setSpectator", false);
                this.$store.commit("session/setSessionId", "");
                if (this.session.nomination) {
                    this.$store.commit("session/nomination");
                }
                this.$store.commit("players/clear");

                this.$store.commit("session/clearVoteHistory");
                this.$store.commit("session/setSpectator", false);
                this.$store.commit("session/setSessionId", String(response.sessionId));
                // 添加玩家
                if (Number(response.count) > 0) {
                    for (let i = 0; i < response.count; i++) {
                        this.$store.commit("players/add", `${i + 1}号玩家`);
                    }
                }
                this.$store.commit(
                    "session/setSessionUserInfo",
                    JSON.parse(decodeURIComponent(this.$utils.cookie("UserCookie")))
                );

                // this.copySessionUrl();
            });

            // this.$alert({
            //     title: "输入你想创建的房间号码/名称",
            //     value: Math.round(Math.random() * 10000)
            // }).then(sessionId => {
            //     this.$store.commit("session/clearVoteHistory");
            //     this.$store.commit("session/setSpectator", false);
            //     this.$store.commit("session/setSessionId", String(sessionId));
            //     this.copySessionUrl();
            // });
        },
        copySessionUrl() {
            const url = window.location.href.split("#")[0];
            const link = url + "#" + this.session.sessionId;
            navigator.clipboard.writeText(link);
        },
        distributeRoles() {
            if (this.session.isSpectator) return;
            const popup = "你想要将选定的角色分配给所有已经入座的玩家吗？";
            if (confirm(popup)) {
                this.$store.commit("session/distributeRoles", true);
                setTimeout(
                    (() => {
                        this.$store.commit("session/distributeRoles", false);
                    }).bind(this),
                    2000
                );
                setTimeout(() => {
                    Bus.$emit("createSession", true);
                }, 1000);
            }
        },
        imageOptIn() {
            const popup =
                "Are you sure you want to allow custom images? A malicious script file author might track your IP address this way.";
            if (this.grimoire.isImageOptIn || confirm(popup)) {
                this.toggleImageOptIn();
            }
        },
        joinSession() {
            if (!this.$utils.cookie("UserCookie")) {
                this.toggleModal("loginBox");
                return;
            }
            if (this.session.sessionId) return this.leaveSession();
            this.$alert({
                title: "输入你想加入的频道号码/名称"
            }).then(sessionId => {
                this.$store.commit("session/setSpectator", false);
                this.$store.commit("session/setSessionId", "");
                if (this.session.nomination) {
                    this.$store.commit("session/nomination");
                }
                this.$store.commit("players/clear");

                if (sessionId.match(/^https?:\/\//i)) {
                    sessionId = sessionId.split("#").pop();
                }
                if (sessionId) {
                    this.$store.commit("session/clearVoteHistory");
                    this.$store.commit("session/setSpectator", true);
                    this.$store.commit("toggleGrimoire", false);
                    this.$store.commit("session/setSessionId", sessionId);
                }
                this.$store.commit(
                    "session/setPlayerUserInfo",
                    JSON.parse(decodeURIComponent(this.$utils.cookie("UserCookie")))
                );
            });
        },
        leaveSession() {
            if (confirm("你确定要离开正在进行的游戏吗？")) {
                this.$store.commit("session/setSpectator", false);
                this.$store.commit("session/setSessionId", "");
                if (this.session.nomination) {
                    this.$store.commit("session/nomination");
                }
                this.$store.commit("players/clear");
            }
        },
        loginOut() {
            if (confirm("你确定要退出登录吗？")) {
                this.$store.commit("session/setSpectator", false);
                this.$store.commit("session/setSessionId", "");
                if (this.session.nomination) {
                    this.$store.commit("session/nomination");
                }
                this.$store.commit("players/clear");
                this.$utils.loginOut();
            }
        },
        addPlayer() {
            if (this.session.isSpectator) return;
            if (this.players.length >= 20) return;
            this.$alert({
                title: "玩家名称"
            }).then(name => {
                if (name) {
                    this.$store.commit("players/add", name);
                }
            });
        },
        randomizeSeatings() {
            if (this.session.isSpectator) return;
            if (confirm("你确定随机安排座位吗?")) {
                this.$store.dispatch("players/randomize");
            }
        },
        clearPlayers() {
            if (this.session.isSpectator) return;
            if (confirm("你确定要删除所有玩家吗?")) {
                // abort vote if in progress
                if (this.session.nomination) {
                    this.$store.commit("session/nomination");
                }
                this.$store.commit("players/clear");
            }
        },
        clearRoles() {
            if (confirm("你希望移除所有对玩家的标记吗？")) {
                this.$store.dispatch("players/clearRoles");
            }
        },
        toggleNight() {
            this.$store.commit("toggleNight");
            if (this.grimoire.isNight) {
                this.$store.commit("session/setMarkedPlayer", -1);
            }
        },
        loadPresetCard(PresetCard) {
            if (this.session.isSpectator) return;
            this.players.forEach(item => {
                this.updatePlayer(item, 'id', '', true, null);
            });

            try {
                const data = PresetCard;
                const { bluffs, edition, roles, fabled, players } = data;
                if (roles) {
                    this.$store.commit("setCustomRoles", roles);
                }
                if (edition) {
                    this.$store.commit("setEdition", edition);
                }
                if (bluffs.length) {
                    bluffs.forEach((role, index) => {
                        this.$store.commit("players/setBluff", {
                            index,
                            role: this.$store.state.roles.get(role) || {}
                        });
                    });
                }
                if (fabled) {
                    this.$store.commit("players/setFabled", {
                        fabled: fabled.map(
                            f => this.$store.state.fabled.get(f) || this.$store.state.fabled.get(f.id) || f
                        )
                    });
                }
                if (players) {
                    this.$store.commit(
                        "players/set",
                        players.map(player => ({
                            ...player,
                            role:
                                this.$store.state.roles.get(player.role) ||
                                this.$store.getters.rolesJSONbyId.get(player.role) ||
                                {}
                        }))
                    );
                }
                // this.toggleModal("gameState");
            } catch (e) {
                alert("Unable to parse JSON: " + e);
            }
        },
        updatePlayer(player, property, value, closeMenu = false, userInfo = undefined) {
            if (this.session.isSpectator && property !== "pronouns") return;
            this.$store.commit("players/update", {
                player: player,
                property,
                value,
                userInfo: userInfo
            });
            if (closeMenu) {
                this.isMenuOpen = false;
            }
        },
        // 生成玩家海报
        generatePoster() {
            let that = this;
            this.$inputs({
                title: "生成玩家海报"
            }).then(response => {
                let canvas = document.createElement("canvas");
                canvas.width = 1242;
                if (!response.shopName && !response.shopAddress && !response.code) {
                    canvas.height = 1853;
                } else {
                    canvas.height = 2234;
                }
                let canvasContext = canvas.getContext("2d");
                // canvasContext.rect(0, 0, canvas.width, canvas.height);
                let SmallPictureBg = new Image();
                SmallPictureBg.src = require("../assets/generateBg.jpg");
                SmallPictureBg.crossOrigin = "Anonymous";
                SmallPictureBg.onload = function() {
                    canvasContext.drawImage(SmallPictureBg, 0, 0, 1242, 2234); //添加背景

                    //游戏
                    let ctx = canvas.getContext("2d");
                    ctx.font = "bold 85px 楷体";
                    ctx.fillStyle = "#df2022";
                    ctx.textAlign = "center";
                    ctx.fillText(response.name, 730, 660);

                    let ctx2 = canvas.getContext("2d");
                    ctx2.font = " bold 85px 楷体";
                    ctx2.fillStyle = "#df2022";
                    ctx2.textAlign = "center";
                    ctx2.fillText(response.prize, 620, 1540);

                    // 添加店铺名
                    if (response.shopName) {
                        let ctxShopName = canvas.getContext("2d");
                        ctxShopName.font = " bold 82px 楷体";
                        ctxShopName.fillStyle = "#ffffff";
                        ctx2.textAlign = "left";
                        ctxShopName.fillText(response.shopName, 276, 1950);
                    }

                    // 添加店铺地址
                    if (response.shopAddress) {
                        let ctxShopAddress = canvas.getContext("2d");
                        ctxShopAddress.font = "28px 楷体";
                        ctx2.textAlign = "left";
                        ctxShopAddress.fillStyle = "#ffffff";

                        if (response.shopAddress.length > 16) {
                            let textList = response.shopAddress.split("");
                            let text = [];
                            let canvasY = 2026;
                            textList.forEach((item, index) => {
                                console.log(text);
                                if (index < textList.length - 1) {
                                    if (text.length < 16) {
                                        text.push(item);
                                    } else {
                                        ctxShopAddress.fillText(text.join(""), 187, canvasY);
                                        canvasY += 35;
                                        text = [];
                                    }
                                } else {
                                    ctxShopAddress.fillText(text.join(""), 187, canvasY);
                                    text = [];
                                }
                            });
                        } else {
                            ctxShopAddress.fillText(response.shopAddress, 187, 2026);
                        }
                    }

                    function downLoadImage(Url) {
                        if (that.$utils.browser.IsMobile()) {
                            that.$store.commit("setGeneratePosterImage", Url);
                            that.toggleModal("generatePoster");
                        } else {
                            let a = document.createElement("a");
                            a.setAttribute("href", Url);
                            a.setAttribute("download", "血染钟楼玩家海报.jpg");
                            a.click();
                            a.remove();
                        }
                    }

                    // 添加二维码
                    if (response.code) {
                        let codeImage = new Image();
                        codeImage.src = response.code;
                        codeImage.onload = function() {
                            canvasContext.drawImage(codeImage, 811, 1867, 192, 192); //添加二维码
                            downLoadImage(canvas.toDataURL());
                        };
                    } else {
                        downLoadImage(canvas.toDataURL());
                    }
                };
            });
            this.$utils
                .AjaxJsonp("//click.gamersky.com/Common/GetHits.aspx", {
                    id: 1478656,
                    script: 3
                })
                .then(response => {});
        },
        gotozq() {
            this.$utils
                .AjaxJsonp("//click.gamersky.com/Common/GetHits.aspx", {
                    id: 1482276,
                    script: 3
                })
                .then(response => {});
            let a = document.createElement("a");
            a.href = "https://www.gamersky.com/z/gsclocktower/";
            a.target = "_blank";
            a.click();
            a.remove();
        },
        ...mapMutations([
            "toggleGrimoire",
            "toggleMenu",
            "toggleImageOptIn",
            "toggleMuted",
            "toggleNightOrder",
            "toggleStatic",
            "setZoom",
            "toggleModal"
        ])
    }
};
</script>

<style scoped lang="scss">
@import "../vars.scss";

// success animation
@keyframes greenToWhite {
    from {
        color: green;
    }
    to {
        color: white;
    }
}

// Controls
#controls {
    position: absolute;
    right: 3px;
    top: 3px;
    text-align: right;
    padding-right: 50px;
    z-index: 75;

    .AddGroup {
        display: inline-block;
        transform: translateY(6px);
        margin-right: 10px;
        vertical-align: top;
        a {
            display: block;
            font-size: 14px;
            text-decoration: none;
            color: #fff;
            &:hover {
                color: red;
            }
        }
    }
    .GameIntroduction {
        display: inline-block;
        border: 3px solid black;
        box-shadow: 0 0 10px #000;
        border-radius: 10px;
        padding: 0 5px;
        text-decoration: none;
        color: #fff;
        background: rgba(0, 0, 0, 0.7);
        &:hover {
            color: red;
        }
    }

    svg {
        filter: drop-shadow(0 0 5px rgba(0, 0, 0, 1));
        &.success {
            animation: greenToWhite 1s normal forwards;
            animation-iteration-count: 1;
        }
    }

    > span {
        display: inline-block;
        cursor: pointer;
        z-index: 5;
        margin-top: 7px;
        margin-left: 10px;
    }

    span.nomlog-summary {
        color: $townsfolk;
    }

    span.session {
        color: $demon;
        &.spectator {
            color: $townsfolk;
        }
        &.reconnecting {
            animation: blink 1s infinite;
        }
    }
}

@keyframes blink {
    50% {
        opacity: 0.5;
        color: gray;
    }
}

.menu {
    width: 220px;
    transform-origin: 200px 22px;
    transition: transform 500ms cubic-bezier(0.68, -0.55, 0.27, 1.55);
    transform: rotate(-90deg);
    position: absolute;
    right: 0;
    top: 0;

    &.open {
        transform: rotate(0deg);
    }

    > svg {
        cursor: pointer;
        background: rgba(0, 0, 0, 0.5);
        border: 3px solid black;
        width: 40px;
        height: 50px;
        margin-bottom: -8px;
        border-bottom: 0;
        border-radius: 10px 10px 0 0;
        padding: 5px 5px 15px;
    }

    a {
        color: white;
        text-decoration: none;
        &:hover {
            color: red;
        }
    }

    ul {
        display: flex;
        list-style-type: none;
        padding: 0;
        margin: 0;
        flex-direction: column;
        overflow: hidden;
        box-shadow: 0 0 10px black;
        border: 3px solid black;
        border-radius: 10px 0 10px 10px;

        .cardGroup {
            color: white;
            text-align: left;
            min-height: 30px;
            font-size: 0.8em;
            cursor: pointer;

            .cardTypeName {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 2px 5px;
                color: white;
                text-align: left;
                background: rgba(0, 0, 0, 0.7);
                min-height: 30px;
                font-size: 0.8em;

                &:hover {
                    cursor: pointer;
                    color: red;
                }
            }
        }
        li {
            padding: 2px 5px;
            color: white;
            text-align: left;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            align-items: center;
            justify-content: space-between;
            min-height: 30px;
            font-size: 0.8em;

            &.tabs {
                display: flex;
                padding: 0;
                svg {
                    flex-grow: 1;
                    flex-shrink: 0;
                    height: 35px;
                    border-bottom: 3px solid black;
                    border-right: 3px solid black;
                    padding: 5px 0;
                    cursor: pointer;
                    transition: color 250ms;
                    &:hover {
                        color: red;
                    }
                    &:last-child {
                        border-right: 0;
                    }
                }
                &.grimoire .fa-book-open,
                &.players .fa-users,
                &.characters .fa-theater-masks,
                &.session .fa-broadcast-tower,
                &.help .fa-question {
                    background: linear-gradient(to bottom, $townsfolk 0%, rgba(0, 0, 0, 0.5) 100%);
                }
            }

            &:not(.headline):not(.tabs):hover {
                cursor: pointer;
                color: red;
            }

            em {
                flex-grow: 0;
                font-style: normal;
                margin-left: 10px;
                font-size: 80%;
            }

            &.presetcardsList {
                display: block;
                .tabTitle {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .presetcard-box {
                    display: block;
                    a {
                        display: block;
                        padding-left: 20px;
                        font-size: 0.6em;
                        margin-bottom: 5px;
                        &:last-of-type {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }

        .headline {
            font-family: PiratesBay, sans-serif;
            letter-spacing: 1px;
            padding: 0 10px;
            text-align: center;
            justify-content: center;
            background: linear-gradient(
                to right,
                $townsfolk 0%,
                rgba(0, 0, 0, 0.5) 20%,
                rgba(0, 0, 0, 0.5) 80%,
                $demon 100%
            );
        }
    }
}
@media screen and (max-width: 500px) {
    .menu {
        ul {
            li {
                font-size: 1.8em;
                &.presetcardsList {
                    font-size: 1.8em;
                    .presetcard-box {
                        a {
                            font-size: 0.8em;
                        }
                    }
                }
            }
            .cardGroup {

                .cardTypeName {
                    font-size: 1.8em;
                }
            }
        }
    }
}
</style>
